
import Vue from 'vue'
import PageMenuLayout from '@/layouts/PageMenu.vue'
import BaseSubNavContainer from '@/containers/base/BaseSubNavContainer.vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import {isEmptyObject} from '@/helpers'

const prospectModule = namespace('prospect')
const uiModule = namespace('ui')

@Component({
  components: {
    PageMenuLayout,
    BaseSubNavContainer
  }
})
export default class ProspectDetail extends Vue {
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @prospectModule.Action('nextProspectAction') nextProspect: any
  @prospectModule.Action('prevProspectAction') prevProspect: any
  @prospectModule.Getter('prospectsGetter') prospects: any
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Getter('prospectSortParamsGetter') prospectSortParams: any
  @prospectModule.Getter('prospectPaginationParamsGetter') prospectPaginationParams: any
  @prospectModule.Getter('prospectFilterParamsGetter') prospectFilterParams: any
  @uiModule.Getter('isLoadingGetter') isLoading: any

  get breadcrumb() {
    return this.prospect && this.prospect.NOM ? `${this.prospect.ID} - ${this.prospect.NOM}` : this.prospect.ID
  }

  get fullTitle() {
    return this.prospect ? `Prospect ${this.prospect.NOM}` : ''
  }

  get title() {
    return this.prospect ? this.prospect.NOM : ''
  }

  get nbContact() {
    return this.prospect && this.prospect.CONTACTS.length > 0 ? this.prospect.CONTACTS.length : ''
  }

  get nbEchange() {
    return this.prospect && this.prospect.ECHANGES.length > 0 ? this.prospect.ECHANGES.length : ''
  }

  get nbProposition() {
    return this.prospect && this.prospect.PROPOSITIONS.length > 0 ? this.prospect.PROPOSITIONS.length : ''
  }

  get nbAlerte() {
    return this.prospect && this.prospect.ALERTES.length > 0 ? this.prospect.ALERTES.length : ''
  }

  get nbEssai() {
    return this.prospect && this.prospect.ESSAIS.length > 0 ? this.prospect.ESSAIS.length : ''
  }

  get nbDocument() {
    return this.prospect && this.prospect.DOCUMENTS.length > 0 ? this.prospect.DOCUMENTS.length : ''
  }

  get nbFormulaire() {
    return this.prospect && this.prospect.FORMULAIRE_WWW.length > 0 ? this.prospect.FORMULAIRE_WWW.length : ''
  }

  get badgeClassForCloture() {
    return this.prospect && this.prospect.DATE_CLOTURE !== null ? 'bg-red' : ''
  }

  get badgeClassForClient() {
    return this.prospect && this.prospect.ID_CLIENT !== null ? 'bg-green' : ''
  }

  get lastQueryParams() {
    return {
      ...this.prospectSortParams,
      ...this.prospectFilterParams,
      page: this.prospectPaginationParams ? this.prospectPaginationParams.page : null
    }
  }

  get hasFilters() {
    const arr = Object.keys(this.lastQueryParams)
    const arrFiltered = arr.filter((item: any) => item !== 'page')
    return arrFiltered.length > 0
  }

  get query() {
    if (this.hasFilters) {
      return {...this.lastQueryParams, action: 'filtre'}
    } else {
      return {...this.lastQueryParams}
    }
  }

  @Watch('$route.params.id', {deep: false})
  async watchRouteParams(val: any) {
    this.getProspectByIdHandler(val)
  }

  async mounted() {
    this.getProspectByIdHandler(this.$route.params.id)
  }

  async getProspectByIdHandler(id) {
    try {
      await this.getProspectById(id)
    } catch (error) {
      Vue.notify({
        group: 'user',
        type: 'warn',
        title: 'Attention',
        text: `Le prospect ${this.$route.params.id} n'existe pas, vous allez être redirigé sur la liste des prospects'`
      })
      this.$router.replace({name: 'prospectList'})
    }
  }
}
